<!-- <link rel="stylesheet" href="../../custom.css"> -->
<template>
  <div class="box" :class="boxPosition">
    <ion-button class="button">{{text}}</ion-button>
  </div>
</template>

<script>
import {IonButton} from "@ionic/vue";

export default {
  name: "confirmButton",
  props: {
    text: {type: String, default: '確定'},
    position: {type: String, default: 'absolute'},
  },
  data() {
    return {
      boxPosition: 'absolute',
    }
  },
  components: {
    IonButton
  },
  mounted() {
    if (this.position === 'relative') {
      this.boxPosition = 'relative'
    }
  }
}
</script>

<style scoped>
.box{
  margin: 0 auto;
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
}
.button{
  --background: #94c43b;
  --padding-top: clamp(0.5rem, 1.4vw, 0.875rem);
  --padding-bottom: clamp(0.5rem, 1.4vw, 0.875rem);
  width: 100%;
  min-height: var(--ecs-button-min-height);
  /* height: auto; */
  white-space: normal;
  font-size: var(--ecs-font-md);
  line-height: 1.3;
}
.absolute{
  position: absolute;
  bottom: clamp(1rem, 3vw, 2rem);
  left: 50%;
  transform: translate(-50%, 0);
  /*margin-left: -22.5vh;*/
}
.relative{
  position: relative;
  text-align: center;
  margin: clamp(1rem, 2vw, 2rem) auto;
}
</style>
